import { useEffect, useState } from "react";
import { Paper, InputBase, IconButton, useTheme } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";

import { RootState, store } from "@store/store";
import { setFullSearchText, setFullSearching } from "@store/slices/sessionSlice";

export const CampoBusquedaSolicitudes = () => {
    const theme = useTheme();
    const dispatch = useDispatch();

    const [text, setText] = useState<string>("");

    const fullSearchState = useSelector((state: RootState) => state.session.filters.shared_filters.fullSearch);

    const fullSearch = (state = store.getState()) => state.session.filters.shared_filters.fullSearch;

    const handleSearchClicked = () => {
        dispatch(setFullSearchText(text ?? ""));
        dispatch(setFullSearching(true));
    };

    const handleClearSearchClicked = () => {
        setText("");

        dispatch(setFullSearchText(""));
        dispatch(setFullSearching(true));
    };

    useEffect(() => {
        if (fullSearch(store.getState()).text.length === 0) return;

        setText(fullSearch(store.getState()).text);
    }, [fullSearch(store.getState())]);

    return (
        <Paper
            component={"form"}
            sx={{
                // filter: "blur(4px)",
                minWidth: "45%",
                border: "2px solid",
                borderColor: theme.palette.main2.main,
                borderRadius: "6px",
                p: "0px 10px",
                display: "flex",
                alignItems: "center",
            }}
        >
            <InputBase
                sx={{
                    flex: 1,
                }}
                value={text}
                onKeyUp={(event) => {
                    if (event.key === "Enter") {
                        handleSearchClicked();
                    }
                }}
                onKeyDown={(event) => {
                    if (event.key === "Enter") event.preventDefault();
                }}
                onChange={(event) => {
                    setText(event.target.value);
                }}
            />
            {text.length !== 0 && fullSearchState.searching === false && (
                <IconButton onClick={handleClearSearchClicked}>
                    <CloseIcon />
                </IconButton>
            )}
            <IconButton onClick={handleSearchClicked} loading={fullSearchState.searching}>
                <SearchIcon />
            </IconButton>
        </Paper>
    );
};
